import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeOrderStatus from "./chargeOrderStatus";
import DistributorOrderDetailResponse from "./distributorOrderDetailResponse";
import KioskOrderDetailResponse from "./kioskOrderDetailResponse";
import SourceType from "./sourceType";
import ChargeOrderPaymentDisplayType from "./chargeOrderPaymentDisplayType";
import EshopTransferOrderDetailResponse from "./eshopTransferOrderDetailResponse";
import EshopPayGateOrderDetailResponse from "./eshopPayGateOrderDetailResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SingleChargeOrderDetailResponse {
  /**
   * Charge order id.
   */
  id!: string;

  @observable
  status!: ChargeOrderStatus;

  /**
   * Indicates if is bulk charge order.
   */
  @observable
  isBulkChargeOrder!: boolean;

  /**
   * Variable symbol for order.
   */
  @observable
  variableSymbol!: number;

  /**
   * Order created at.
   */
  @observable
  @Type(() => Date)
  createdAt!: Date;

  /**
   * Order confirmed at.
   */
  @observable
  @Type(() => Date)
  confirmedAt?: Date;

  @observable
  sourceType!: SourceType;

  @observable
  chargeOrderPaymentDisplayType?: ChargeOrderPaymentDisplayType;

  /**
   * Total order price.
   */
  @observable
  price!: number;

  @observable
  @Type(() => KioskOrderDetailResponse)
  kioskOrderDetail?: KioskOrderDetailResponse;

  @observable
  @Type(() => DistributorOrderDetailResponse)
  distributorOrderDetail?: DistributorOrderDetailResponse;

  @observable
  @Type(() => EshopTransferOrderDetailResponse)
  eshopTransferOrderDetail?: EshopTransferOrderDetailResponse;

  @observable
  @Type(() => EshopPayGateOrderDetailResponse)
  eshopPayGateOrderDetail?: EshopPayGateOrderDetailResponse;
}
